import { Scene } from 'phaser';
import { TweenAction } from './TweenAction';

export class CallFuncAction extends TweenAction {
  protected callFunc: Function;

  constructor(scene: Scene, callFunc: Function) {
    /**
     * Tweens will only run if there's a property to be modified on at least one target.
     * Use the scene as a target and have the tween modify the 'x' property. This property
     * doesn't apply to scenes, but allows the callFunc to run as desired.
     */
    super(scene, [scene], 0.1);
    this.callFunc = callFunc;
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('x', 0);
    this.setTweenConfigValue('onStart', this.callFunc);
  }
}